import CircularImage from "components/common/CircularImage/CircularImage";
import Typography from "components/common/Typography/Typography";
import React from "react";
import styled from "styled-components";
import Flex from "components/common/Layout/Flex/Flex";
import IconButton from "components/common/IconButton/IconButton";
import Button from "components/common/Button/Button";
import SettingsIcon from "assets/img/common/SettingsIcon";
import {
  DUMMY_PROFILE_DESCRIPTION,
  DUMMY_PROFILE_NAME,
  HEADER_BUTTON_LABEL,
} from "config/profile_constants";
import { useNavigate } from "react-router-dom";

const Wrapper = styled.section`
  display: flex;
  align-items: center;
  gap: 30px;
`;
const ProfileNameAndSubtitle = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;
const HeaderActions = styled(Flex)``;

const HeaderBtn = styled(Button)`
  background-color: ${(props) => props.color};
`;

const ProfileHeader = ({
  profilePicture,
  logoutHandler,
  color,
  showProfilePicture,
  showSettingsIcon,
  showProfileDescription,
}) => {
  return (
    <Wrapper>
      {showProfilePicture ? (
        <CircularImage img={profilePicture} height="183px" width="183px" />
      ) : null}
      <ProfileNameAndSubtitle>
        <Typography variant="h2">{DUMMY_PROFILE_NAME}</Typography>
        {showProfileDescription ? (
          <Typography variant="h3">{DUMMY_PROFILE_DESCRIPTION}</Typography>
        ) : null}
      </ProfileNameAndSubtitle>
      <HeaderActions spacing={`32px`} direction="row">
        <HeaderBtn
          color={color}
          onClick={() => {
            logoutHandler();
          }}
        >
          {HEADER_BUTTON_LABEL}
        </HeaderBtn>
        {showSettingsIcon ? (
          <IconButton>
            <SettingsIcon />
          </IconButton>
        ) : null}
      </HeaderActions>
    </Wrapper>
  );
};

export default ProfileHeader;
